// extracted by mini-css-extract-plugin
export default {"subdate":"SubscriptionDate_subdate__Uaxv8","box":"SubscriptionDate_box__df6X1","title":"SubscriptionDate_title__1Szer","rtl":"SubscriptionDate_rtl__fuuGk"};